import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useLocation } from 'react-router'
const PrivateRoute = props => {
  const { logged } = true
  const navigate = useNavigate()
  const location = useLocation()

  useEffect(() => {}, [])

  return logged ? props.element : <div>test对不起，您没有权限访问此页1。</div>
}

export default PrivateRoute
